import { patientAccessTheme } from '@HomaHealth/ui-component-library';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import React from 'react';
import { getTruncatedText } from '../../pages/MemberSummaryPage';
import { formatDate } from './helper';

export const formatDeepDiveCostTrend = (data: any) => {
  return data.map((item: any) => {
    return [`${item.month}/${item.year}`, item.total_paid_amount];
  });
};

export const formatClaimIDBoxView = (claimDetail: any) => {
  const data: { label: string; value: any }[] = [];
  const outerColumnKeys = Object.keys(claimDetail?.ouputJsonForOuterColumn);
  const outerColumnValues = Object.values(claimDetail?.ouputJsonForOuterColumn);
  for (let i = 0; i < outerColumnKeys.length; i++) {
    if (outerColumnValues[i] !== '' && outerColumnValues[i] !== '-') {
      data.push({
        label: outerColumnKeys[i],
        value: outerColumnValues[i],
      });
    }
  }

  return data;
};

export const formatClaimIDTableDataView = (claimDetail: any) => {
  const arrayData: any = [];
  claimDetail?.lineItemsTable.forEach((lineItems: any) => {
    const line = JSON.parse(JSON.stringify(lineItems));
    arrayData.push(line);
  });
  return arrayData;
};

export const formatClaimIDTableColumnView = (claimDetail: any) => {
  const outerColumnKeys = Object.keys(claimDetail?.lineItemsTable[0]);
  return outerColumnKeys;
};

export const formatClaimIDTableDownloadColumnView = (claimDetail: any) => {
  const values = Object.keys(claimDetail?.tableData[0]);
  const columnArray: {}[] = [];
  values.forEach((column: any) =>
    columnArray.push({
      Header: (
        <Typography
          style={{
            width: '180px',
            fontSize: '14px',
            fontWeight: 500,
            color: patientAccessTheme.palette.text.highemphasis,
          }}
        >
          {column}
        </Typography>
      ),
      Footer: column,
      accessor: column,
      accessorKey: column,
      id: column,
      Cell: ({ value }: any) => <>{getTruncatedText(value, '140px')}</>,
    }),
  );
  return columnArray;
};

export const getDateInfo = (
  payload: any,
  isIncurredDate: boolean,
  isPaidDate: boolean,
) => {
  return isIncurredDate && isPaidDate ? (
    <>
      <Typography
        fontSize="12px"
        lineHeight="20px"
        fontType="medium"
        margin="0px 4px 0px 0px"
      >
        Incurred Date:{' '}
        <b>
          {formatDate(payload.incurredStartDate, 'MMM YYYY')} -{' '}
          {formatDate(payload.incurredEndDate, 'MMM YYYY')}
        </b>
      </Typography>
      <Typography
        fontSize="12px"
        lineHeight="20px"
        fontType="medium"
        margin="0px 4px 0px 4px"
      >
        Paid Date:{' '}
        <b>
          {formatDate(payload.paidStartDate, 'MMM YYYY')} -{' '}
          {formatDate(payload.paidEndDate, 'MMM YYYY')}
        </b>
      </Typography>
    </>
  ) : (
    <>
      {isIncurredDate && (
        <Typography
          fontSize="12px"
          lineHeight="20px"
          fontType="medium"
          margin="0px 4px 0px 0px"
        >
          Incurred Date:{' '}
          <b>
            {formatDate(payload.incurredStartDate, 'MMM YYYY')} -{' '}
            {formatDate(payload.incurredEndDate, 'MMM YYYY')}
          </b>
        </Typography>
      )}
      {isPaidDate && (
        <Typography
          fontSize="12px"
          lineHeight="20px"
          fontType="medium"
          margin="0px 4px 0px 0px"
        >
          Paid Date:{' '}
          <b>
            {formatDate(payload.paidStartDate, 'MMM YYYY')} -{' '}
            {formatDate(payload.paidEndDate, 'MMM YYYY')}
          </b>
        </Typography>
      )}
    </>
  );
};
